<template>
  <div>
    <a
      href="#storefront-main"
      class="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:bg-white focus:px-3 focus:py-2"
    >
      跳到主要內容
    </a>
    <div
      data-desktop-page-shell
      class="m-auto w-full bg-gray-50 max-w-screen-sm h-app desk:h-auto desk:min-h-screen desk:max-w-[1200px] desk:bg-white wide:max-w-[1280px]"
    >
      <DesktopTopNav class="sticky top-0 z-30 hidden desk:block" />
      <!-- 內容 -->
      <div
        id="storefront-main"
        class="h-full overflow-y-scroll scrolling-touch scrollbar-hide desk:h-auto desk:min-h-0 desk:overflow-visible"
      >
        <nuxt />
      </div>
      <!-- 底部導覽 -->
      <div class="fixed inset-x-0 bottom-0 w-full pb-safe desk:hidden">
        <BottomNavigationCard />
      </div>
    </div>

    <!-- 產品詳細 -->
    <van-popup
      v-model="show_popup"
      position="bottom"
      @closed="popupClose"
      @open="show_consent = true"
      class="z-[999999999999] inset-x-0 mx-auto max-w-screen-sm overflow-hidden"
    >
      <component :is="popup_el" v-bind="popup_data" />
    </van-popup>

    <!-- 購物車 -->
    <ShoppingCart />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Specification from "@/components/product/Specification";
import Modal from "@luminexs/components/modal/Modal.vue";
import ShoppingCart from "@/components/cart/ShoppingCart";
import BankLegend from "@/components/takings/BankLegend.vue";
import BottomNavigationCard from "@/components/card/BottomNavigationCard.vue";
import DesktopTopNav from "@/components/app/DesktopTopNav.vue";
import desktop from "@/mixins/desktop";
import { closeOverlayOnEscape } from "@/utils/overlayClose";
import axios from "axios";

export default {
  mixins: [desktop],
  components: {
    Specification,
    ShoppingCart,
    Modal,
    BankLegend,
    BottomNavigationCard,
    DesktopTopNav,
  },
  head() {
    const info = this.$store.getters["app/info"];
    const imgs = this.$store.getters["app/imgs"];
    const cleanDescription = (info.description || "").replace(/(<([^>]+)>)/gi, "").substring(0, 150) + "...";
    const keywords = info.keywords && info.keywords !== "undefined" ? info.keywords : "遊戲點數, 達人商城, 遊戲充值";
    return {
      title: info.name,
      meta: [
        {
          hid: "description",
          name: "description",
          content: cleanDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: info.name,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: cleanDescription,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: imgs.logo,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: info.web,
        },
      ],
      link: [
        {
          rel: "icon",
          type: "image/x-icon",
          href: imgs.logo,
        },
      ],
    };
  },
  data() {
    return {
      show_popup: false,
      show_consent: false,
    };
  },
  methods: {
    ...mapActions({
      popupClose: "popup/close",
      fetchCategories: "app/fetchCategories",
    }),
    onOverlayKeydown(event) {
      closeOverlayOnEscape(event, this.show_popup, () => this.popupClose());
    },
  },
  watch: {
    popup_enable(bool) {
      this.show_popup = bool;
    },
  },
  computed: {
    ...mapGetters({
      popup_enable: "popup/enable",
      popup_el: "popup/el",
      popup_data: "popup/data",
    }),
    showCart() {
      return ["index", "order"].includes(
        this.$route.name?.replace(`___${this.$i18n.locale}`, "") // replace ___ to empty string
      );
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("keydown", this.onOverlayKeydown);
    }
  },
  async mounted() {
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", this.onOverlayKeydown);
    }
    await this.$locale();
    this.fetchCategories();

    if (typeof ssq !== 'undefined' && ssq) {
      if (this._my) {
        ssq.push({
          'user_id': this._my.hashid,
          'user_name': this._my.name,
        })
      }
    }
    
  },
};
</script>
